import OverviewMiniMap from '../OverviewMiniMap/OverviewMiniMap';
import LazyMount from '../OverviewMiniMap/LazyMount';
import Icon from '@/components/ui/Icon/Icon';
import { mapHasContent, mapHasLegend, type MapSpec } from '@/lib/map-spec';
import styles from './ChapterMap.module.css';

export type { LegendGradient, LegendItem } from '@/lib/map-spec';

type Props = {
  spec: MapSpec;
};

// 章のサブマップ = キャプション + 地図 (遅延マウント) + 凡例。中身は MapSpec 1 つで決まる。
export default function ChapterMap({ spec }: Props) {
  const { caption, emptyMessage, legend, legendGradient, height } = spec;
  const hasContent = mapHasContent(spec);
  const hasLegend = mapHasLegend(spec);

  return (
    <div className={styles.wrap}>
      {caption && <div className={styles.caption}>{caption}</div>}
      <LazyMount placeholderHeight={height}>
        <OverviewMiniMap spec={spec} />
      </LazyMount>
      {!hasContent && emptyMessage && (
        <div className={styles.empty}>{emptyMessage}</div>
      )}
      {hasLegend && (
        <div className={styles.legend} role="list">
          {legendGradient && (
            <span className={styles.legendGradientChip} role="listitem">
              <span>{legendGradient.minLabel}</span>
              <span
                className={styles.legendGradientBar}
                role="img"
                aria-label={`左ほど「${legendGradient.minLabel}」、右ほど「${legendGradient.maxLabel}」を表す色の帯`}
                style={{
                  background: `linear-gradient(to right, ${legendGradient.colors.join(', ')})`,
                }}
              />
              <span>{legendGradient.maxLabel}</span>
            </span>
          )}
          {legend.map((item, i) => (
            <span key={i} className={styles.legendChip} role="listitem">
              {item.icon ? (
                <span className={styles.legendIcon} aria-hidden="true">
                  <Icon name={item.icon} size={14} color={item.color} />
                </span>
              ) : item.emoji ? (
                <span className={styles.legendEmoji} aria-hidden="true">
                  {item.emoji}
                </span>
              ) : (
                <span
                  className={styles.legendDot}
                  aria-hidden="true"
                  style={
                    item.outline
                      ? { background: 'transparent', border: `2px solid ${item.color}` }
                      : { background: item.color }
                  }
                />
              )}
              <span>{item.label}</span>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
